import { isAndroid, isIOS } from "@/utils/utils";

import { REMOTE_CONFIG } from "@/env";
import isNil from "lodash/isNil";

const checkKey = (key: string) => {
  if (isAndroid()) {
    if (`${key}_android` in REMOTE_CONFIG) {
      return `${key}_android`;
    }
  } else if (isIOS()) {
    if (`${key}_ios` in REMOTE_CONFIG) {
      return `${key}_ios`;
    }
  }
  return key;
};

export const getRemoteConfigValue = <T>(key: string, defaultValue: T): T => {
  try {
    if (
      !isNil(REMOTE_CONFIG[key])
    ) {
      return REMOTE_CONFIG[key] as T;
    }
    const k = checkKey(key);
    if (
      !isNil(REMOTE_CONFIG[key])
    ) {
      return REMOTE_CONFIG[k] as T;
    }
    return defaultValue;
  } catch (e) {
    return defaultValue;
  }
};
